var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.d{fill:#7b7b7b;opacity:0.37;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34,
    height: 35,
    transform: "translate(0.16 -0.254)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.16 0.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.998 -6.354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.07)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M60.9,628.644a4.248,4.248,0,0,0-3.347,1.648c.188.08.373.14.565.231l-.509,1.091c-.231-.108-.449-.186-.671-.272a4.219,4.219,0,0,0,2.118,5.411l.343-1.281a2.974,2.974,0,0,1-1.516-2.558,3.015,3.015,0,1,1,3.015,3.015,2.942,2.942,0,0,1-.36-.073l-.336,1.26a4.192,4.192,0,0,0,.7.071,4.253,4.253,0,0,0,3.118-1.374l-.263-.19.651-1.016.3.212a4.242,4.242,0,0,0-3.8-6.174Z",
    transform: "translate(-27.616 -614.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M111.439,646.127l-.569-1.061,1.057-.574.129.244,3.705-17.9c-10.164,5.476-15.722,8.307-29.675,0-10.395-6.194-16.643-7.039-33.587,0l-3.638,17.576.986-.4.446,1.119-1.115.448-.369-.914-5.635,27.216c11.7-6.36,18.139-6.843,25.623-5.514,0,0,.138-.084,1.674.662s3.049,2.558,6.291,4.852c13.255,9.387,19.511,5.475,29.673,0l5.374-25.956Zm-58.852-1.919-.455-1.115,2.286-.927.455,1.115Zm4.572-1.852-.455-1.115q1.216-.492,2.3-.919l.44,1.122Zm4.574-1.8-.421-1.123c.841-.319,1.62-.591,2.342-.839l.38,1.143q-1.058.349-2.3.822Zm4.626-1.514-.3-1.18a15.84,15.84,0,0,1,2.517-.451l.11,1.2a15.306,15.306,0,0,0-2.331.434ZM80,624.4l1.162.31-.621,2.327-1.16-.309Zm-1.238,4.654,1.162.308-.623,2.327-1.162-.308ZM70.6,664.277l-1.158-.308.619-2.331,1.162.311Zm1.242-4.654-1.162-.311.623-2.327,1.162.31Zm1.24-4.652-1.162-.311.621-2.327,1.162.31Zm1.244-4.652-1.162-.31.623-2.327,1.162.3Zm6.931-5.445-.714-.515a5.446,5.446,0,0,1-9.2-5.532c-.123-.03-.248-.073-.371-.1l.216-1.18c.233.041.468.116.705.179a5.107,5.107,0,0,1,5.18-2.383l.433-1.628,1.162.308-.425,1.583a5.4,5.4,0,0,1,2.985,7.757l.725.522Zm4.149,2.76q-1.029-.611-2.113-1.339l.675-1q1.061.705,2.066,1.3Zm4.492,2.251c-.751-.3-1.523-.647-2.3-1.039l.543-1.072c.744.373,1.475.71,2.2.99Zm4.9,1.294a18.3,18.3,0,0,1-2.5-.492l.317-1.162a17.028,17.028,0,0,0,2.329.459Zm2.551.119-.035-1.2a15.473,15.473,0,0,0,2.359-.259l.222,1.18a16.794,16.794,0,0,1-2.543.282Zm5.016-.906L102,649.246c.718-.231,1.475-.5,2.262-.843l.466,1.109c-.841.338-1.613.63-2.366.867Zm4.632-1.924-.531-1.083c.714-.347,1.441-.723,2.18-1.111l.563,1.063q-1.132.582-2.217,1.119Z",
    transform: "translate(-43.174 -621.872)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.945-.074C38.516-.954,29,6.511,29,15.263s-4.4,16.382-13.15,16.382A15.847,15.847,0,0,1,0,15.8C0,7.046,7.373.807,22.945-.074Z",
    transform: "translate(0 21.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.933-.074C-6.639-.954,2.88,6.511,2.88,15.263s4.4,16.382,13.149,16.382A15.847,15.847,0,0,0,31.877,15.8C31.877,7.046,24.5.807,8.933-.074Z",
    transform: "translate(42.92 9.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M19.449-.084c13.2-.747,5.13,5.581,5.13,13S20.852,26.8,13.433,26.8A13.433,13.433,0,0,1,0,13.369C0,5.95,6.25.662,19.449-.084Z",
    transform: "translate(2.429 24.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.572-.084c-13.2-.747-5.13,5.581-5.13,13S6.169,26.8,13.587,26.8A13.433,13.433,0,0,0,27.02,13.369C27.02,5.95,20.77.662,7.572-.084Z",
    transform: "translate(45.349 11.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.289-.093c11.055-.637,4.3,4.764,4.3,11.1s-3.122,11.853-9.335,11.853A11.36,11.36,0,0,1,0,11.39C0,5.058,5.234.544,16.289-.093Z",
    transform: "translate(2.428 27.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.342-.093C-4.713-.73,2.045,4.671,2.045,11S5.167,22.856,11.38,22.856A11.36,11.36,0,0,0,22.631,11.39C22.631,5.058,17.4.544,6.342-.093Z",
    transform: "translate(49.738 15.44)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3d00d625ef6e4d760990f8d8549e4006.svg";
export { ForwardRef as ReactComponent };